































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Vacinacao } from '../../../../back/src/entity/Vacinacao';
import { Vacina } from '../../../../back/src/entity/Vacina';

import CustomDialog from '../CustomDialog.vue';
import VacinacoesDetalhes from './VacinacoesDetalhes.vue';
import VacinacoesFormEdit from './VacinacoesFormEdit.vue';
import VacinacoesFormRemover from './VacinacoesFormRemover.vue';

export default Vue.extend({
  name: 'VacinacoesTabela',
  components: {
    CustomDialog,
    VacinacoesDetalhes,
    VacinacoesFormEdit,
    VacinacoesFormRemover,
  },
  props: {
    paciente: {
      type: Object as () => Gestacao,
    },
    gestacao: {
      type: Object as () => Gestacao,
    },
    vacinacoes: {
      type: Array as () => Vacinacao[],
    },
    vacinas: {
      type: Array as () => Vacina[],
    },
  },
  data() {
    return {
      dialogDetalhes: false,
      editVacinacao: false,
      removerVacinacao: false,
      vacinacaoSelecionada: null,
      headers: [
        {
          value: 'vacina.id',
          text: 'Vacina ',
          sortable: false,
        },
        {
          value: 'data_vacinacao',
          text: 'Data ',
          sortable: true,
          align: 'center',
        },
        {
          value: 'actions',
          text: 'Ações',
          sortable: false,
          width: 0,
          align: 'center',
        },
      ],
    };
  },
  methods: {
    detalhesVacinacao(vacinacao: Vacinacao) {
      this.vacinacaoSelecionada = vacinacao;
      this.dialogDetalhes = true;
    },
    atualizaVacinacao(vacinacao: Vacinacao) {
      this.$emit('atualizaVacinacao', vacinacao);
      this.vacinacaoSelecionada = vacinacao;
      this.editVacinacao = false;
    },
    removeVacinacao(vacinacao: Vacinacao) {
      this.$emit('removeVacinacao', vacinacao);
      this.vacinacaoSelecionada = null;
      this.removerVacinacao = false;
      this.dialogDetalhes = false;
    },
  },
});
